import React from "react";
import CallIcon from "@mui/icons-material/Call";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../components/ModalComponent";
import ButtonComponent from "../../components/ButtonComponent";
import classes from "./index.module.scss";

function Index({
  openAlertCall,
  closeAlertCall,
  acceptCall,
  roomCall,
  defaultUserImage,
  ringtone,
  loading,
}) {
  const { t } = useTranslation();

  return (
    <ModalComponent
      open={openAlertCall}
      handleClose={closeAlertCall}
      closeBtn={true}
      confirmBtn={false}
      handleOk={null}
      title={t("components.alertCall.title")}
    >
      <div className={classes.mainContainer}>
        <img
          src={roomCall?.picture ? roomCall.picture : defaultUserImage}
          alt="userImage"
          className={classes.img}
        />
        <h2>
          {roomCall?.nickname + " " + roomCall?.fullname}{" "}
          {t("components.alertCall.isCalling")}
        </h2>
        <audio preload="none" src={ringtone} loop autoPlay={true} />
        <div className={classes.fabContainer}>
          <ButtonComponent
            backgroundColor={"green"}
            icon={<CallIcon />}
            onClick={acceptCall}
            loading={loading}
          >
            {t("components.alertCall.accept")}
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}

export default Index;
